import CryptoJS from "crypto-js";

export const encryptPayload = (data: any) => {
  try {
    const configSeed = process.env.CONFIG_SEED;
    const metaHash = process.env.META_HASH;

    if (!configSeed || !metaHash) {
      throw new Error(
        "Environment variables CONFIG_SEED and META_HASH must be defined",
      );
    }

    const keyUtf8 = CryptoJS.enc.Utf8.parse(configSeed);
    const ivUtf8 = CryptoJS.enc.Utf8.parse(metaHash);
    // Convert the input to string if it's an object
    const dataWithTimeStamp = {
      ...data,
      timestamp: Date.now(),
    };

    const textString = JSON.stringify(dataWithTimeStamp);

    // Encrypt the data
    const encrypted = CryptoJS.AES.encrypt(textString, keyUtf8, {
      iv: ivUtf8,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Combine encrypted data and IV with separator
    const encryptedBase64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);

    return encryptedBase64;
  } catch (error) {
    console.error("Encryption error:", error);
    throw error;
  }
};

// export const decryptPayload = (encrypted: string) => {
//   try {
//     const keyUtf8 = CryptoJS.enc.Utf8.parse(KEY);
//     const parts = encrypted.split("|");

//     if (parts.length !== 2) {
//       throw new Error("Invalid encrypted string format");
//     }

//     const [encryptedBase64, ivBase64] = parts;

//     // Create CipherParams object
//     const cipherParams = CryptoJS.lib.CipherParams.create({
//       ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64),
//     });

//     // Decrypt
//     const decrypted = CryptoJS.AES.decrypt(cipherParams, keyUtf8, {
//       iv: CryptoJS.enc.Base64.parse(ivBase64),
//       mode: CryptoJS.mode.CBC,
//       padding: CryptoJS.pad.Pkcs7,
//     });

//     const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
//     console.log("Decrypted string:", decryptedString);

//     // Try to parse as JSON if it was originally an object
//     try {
//       return JSON.parse(decryptedString);
//     } catch {
//       return decryptedString;
//     }
//   } catch (error) {
//     console.error("Decryption error:", error);
//     throw error;
//   }
// };

// // Test function
// export const testEncryptionDecryption = () => {
//   const testData = { email: "atyagi91@yopmail.com" };
//   console.log("\n=== Testing Encryption/Decryption ===");
//   console.log("Original data:", testData);

//   // Encrypt
//   const encrypted = encryptPayload(testData);
//   console.log("\nEncrypted string:", encrypted);

//   // Decrypt
//   const decrypted = decryptPayload(encrypted);
//   console.log("\nDecrypted data:", decrypted);

//   // Verify
//   console.log(
//     "\nVerification:",
//     JSON.stringify(testData) === JSON.stringify(decrypted)
//       ? "SUCCESS: Encryption/Decryption working correctly!"
//       : "FAILED: Decrypted data does not match original!",
//   );
// };
